
import './ProfileSectionContainer.scss';
export default function ProfileSectionContainer(props: any) {
    return (
        <div className="sc-eKZiaR ipYzEx ">{props.children}</div>
    );
}